// extracted by mini-css-extract-plugin
module.exports = {"overlay":"card_overlay__m89QW","petCareCardHolder":"card_petCareCardHolder__HNRY1"};